import { Powers } from "../types/FormContract";

export const allPowersFull = (
  powers: Powers
) => (
  powers.installationType === "industrial" ? 
  (
    powers.periods[0] > 0 && 
    powers.periods[1] >= powers.periods[0] && 
    powers.periods[2] >= powers.periods[1] && 
    powers.periods[3] >= powers.periods[2] && 
    powers.periods[4] >= powers.periods[3] && 
    powers.periods[5] >= powers.periods[4]
  ) 
  : (
    powers.periods[0] > 0 && 
    powers.periods[1] >= powers.periods[0]
  )
);